import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../../Axios";

const AddMouForm = () => {
  const [formData, setFormData] = useState({ listHead: "" });
  const [pdf, setPdf] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setPdf(e.target.files[0]); // Corrected here
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const form = new FormData();
    form.append("listHead", formData.listHead);
    if (pdf) {
      form.append("pdf", pdf); // Backend expects 'pdf' key
    }

    try {
      const response = await api.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/mouList/create`,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Mou added successfully!");
      setFormData({ listHead: "" });
      setPdf(null);
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-6">
      <motion.div
        className="bg-white shadow-xl rounded-lg p-10 w-full max-w-3xl"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h2
          className="text-3xl font-semibold text-white text-center py-4 mb-8 rounded-t-lg"
          style={{ backgroundColor: "#00BFA5" }}
        >
          Add New Mou
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label
              htmlFor="listHead"
              className="block text-gray-600 text-sm font-medium mb-2"
            >
              Title / List Head
            </label>
            <input
              type="text"
              id="listHead"
              name="listHead"
              value={formData.listHead}
              onChange={handleChange}
              placeholder="Enter title"
              required
              className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="file"
              className="block text-gray-600 text-sm font-medium mb-2"
            >
              Upload PDF File
            </label>
            <input
              type="file"
              id="file"
              name="pdf"
              onChange={handleFileChange}
              required
              accept="application/pdf"
              className="w-full px-6 py-3 border border-gray-300 rounded-lg text-gray-700"
            />
          </div>

          <motion.button
            type="submit"
            className={`w-48 mx-auto py-3 rounded-lg font-semibold shadow-md focus:outline-none focus:ring-2 ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#00BFA5] hover:bg-[#00BFA5] text-white"
            }`}
            disabled={loading}
            whileTap={{ scale: 0.98 }}
            style={{ fontSize: "1rem" }}
          >
            {loading ? "Adding..." : "Add Mou"}
          </motion.button>
        </form>
      </motion.div>
      <ToastContainer />
    </div>
  );
};

export default AddMouForm;
